<div class="upload-container">

    <!-- ====================================================== -->
    <!-- DROPZONE -->
    <!-- ====================================================== -->

    <ngx-dropzone
        class="custom-dropzone"
        [class.custom-dropzone-with-files]="(files?.length || 0) > 0"
        (change)="onSelect($event)"
        [multiple]="multiple"
        [accept]="extensionFiles(extension)">


        <!-- ================================================== -->
        <!-- MENSAJE PRINCIPAL -->
        <!-- Solo se muestra cuando NO existen archivos -->
        <!-- ================================================== -->

        <ngx-dropzone-label
            class="dropzone-main-label"
            *ngIf="!files?.length">

            <div class="dropzone-content">

                <div class="upload-icon">
                    <i class="fa-solid fa-cloud-arrow-up"></i>
                </div>

                <div class="upload-info">

                    <span class="upload-title">
                        Arrastre los archivos aquí
                    </span>

                    <span class="upload-description">
                        o haga clic para seleccionarlos desde su dispositivo
                    </span>

                </div>

                <span class="upload-action">
                    Seleccionar archivos
                </span>

            </div>

        </ngx-dropzone-label>


        <!-- ================================================== -->
        <!-- ARCHIVOS SELECCIONADOS -->
        <!-- ================================================== -->

        <div
            class="files-container"
            *ngIf="files?.length"
            (click)="$event.stopPropagation()">

            <div
                class="file-card"
                *ngFor="let file of files"
                (click)="$event.stopPropagation()">

                <!-- ICONO -->

                <div class="file-icon">

                    <i class="fa-solid fa-file"></i>

                </div>


                <!-- INFORMACIÓN -->

                <div class="file-info">

                    <span
                        class="file-name"
                        [title]="file.name">

                        {{ file.name }}

                    </span>

                    <span class="file-size">

                        {{
                            file.size / (1024 * 1024)
                            | number: '1.2-2'
                        }}

                        MB

                    </span>

                </div>


                <!-- ================================================== -->
                <!-- ELIMINAR -->
                <!-- ================================================== -->

                <button
                    type="button"
                    class="file-remove-btn"
                    title="Eliminar archivo"
                    aria-label="Eliminar archivo"
                    (click)="
                        $event.preventDefault();
                        $event.stopPropagation();
                        onRemove(file)
                    ">

                    <i class="fa-solid fa-xmark"></i>

                </button>

            </div>

        </div>

    </ngx-dropzone>


    <!-- ====================================================== -->
    <!-- INFORMACIÓN -->
    <!-- ====================================================== -->

    <div
        class="file-requirements"
        *ngIf="visible">

        <i class="fa-solid fa-circle-info"></i>

        <span>

            Formatos permitidos:

            <strong>
                {{ mesageExtension }}
            </strong>

            <span class="requirement-separator">
                •
            </span>

            Tamaño máximo:

            <strong>
                {{ maxFileSize }} MB
            </strong>

        </span>

    </div>

</div>